import { render, staticRenderFns } from "./langauge-switcher.vue?vue&type=template&id=dcf97cf2&"
import script from "./langauge-switcher.vue?vue&type=script&lang=js&"
export * from "./langauge-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../usr/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports